var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { LoadingPane } from "@folio/stripes/components";
import PublisherPrefixForm from "./PublisherPrefixForm";
import { fetchPublisherPrefixById, transferPublisherPrefix, } from "../../api/publisherPrefixService";
var PublisherPrefixEdit = function () {
    var history = useHistory();
    var queryClient = useQueryClient();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var id = useParams().id;
    var _a = useState(null), publisherPrefix = _a[0], setPublisherPrefix = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading(true);
                        return [4 /*yield*/, fetchPublisherPrefixById(ky, id)];
                    case 1:
                        data = _a.sent();
                        setPublisherPrefix(data);
                        setError(null);
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        setError("Failed to load publisherPrefix data");
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, transferPublisherPrefix(ky, id, data.publisher.id)];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(["publisher-prefixes"]);
                    queryClient.invalidateQueries(["publisherPrefix"]);
                    history.push("/bragency/publisher-prefixes");
                    return [2 /*return*/];
            }
        });
    }); };
    if (isLoading) {
        return React.createElement(LoadingPane, null);
    }
    if (error || !publisherPrefix) {
        return (React.createElement("div", null,
            "Error:",
            " ",
            error ||
                formatMessage({ id: "ui-br-agency.publisher-prefix.not.found})" })));
    }
    return (React.createElement(PublisherPrefixForm, { initialValues: publisherPrefix, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-agency.publisher-prefix.edit.pane.title",
        }) }));
};
export default PublisherPrefixEdit;
